import { createFileRoute, useParams } from '@tanstack/react-router';
import { z } from 'zod';

import { ClientDetailScreen } from '@/features/clients/components/shared/ClientDetailScreen';

const searchSchema = z.object({
  tab: z
    .enum(['profile', 'history', 'red-flags', 'assessments', 'exercises', 'engagement', 'phi'])
    .catch('profile')
    .optional(),
  // Set when the user reached this detail page from the "All clients" mode
  // on the list screen. Drives a non-clickable timeline in the History tab
  // because the underlying session-detail pages would be empty for clients
  // the user has no sessions with.
  fromAll: z.boolean().optional(),
  // History-tab drawer state. Mirrors /app/sessions search shape so the
  // same SessionPanel UI can mount on top of this route without navigating
  // away. Only used by the History tab; profile / red-flags / etc ignore it.
  panel: z.enum(['session']).optional(),
  id: z.string().optional(),
  // Optional rather than .default('overview') so existing typed Links to
  // `/app/clients/$clientId` (ClientHeader, ClientPanel back-link, etc.)
  // don't need to start passing `search`. The drawer falls back to
  // 'overview' at the consumption site.
  drawerTab: z.enum(['overview', 'notes', 'transcript', 'case-reports', 'feedback']).optional(),
});

export const Route = createFileRoute('/app/clients/$clientId/')({
  component: ClinicalClientDetailRoute,
  validateSearch: searchSchema.parse.bind(searchSchema),
});

function ClinicalClientDetailRoute() {
  const { clientId } = useParams({ from: '/app/clients/$clientId/' });
  return <ClientDetailScreen clientId={clientId} surface="clinical" />;
}
